import { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hook";
import {
  getAllDamTypes,
  getDamTypeById,
  createDamType,
  updateDamType,
  deleteDamType,
} from "src/services/damServices";
import {
  DAM_TYPES_GET_ALL,
  DAM_TYPES_GET_BY_ID,
  DAM_TYPES_ADD,
  DAM_TYPES_UPDATE,
  DAM_TYPES_DELETE,
} from "src/store/damType/action";

function useDamType() {
  const { damTypes, selectedDamType } = useAppSelector((state) => state.damType);
  const dispatch = useAppDispatch();
  const [isLoading, setLoading] = useState(false);

  // Lấy tất cả loại đập
  const fetchDamTypes = async () => {
    try {
      setLoading(true);
      const response = await getAllDamTypes();
      dispatch(DAM_TYPES_GET_ALL({ damTypes: response.data }));
    } catch (error) {
      console.error("Error fetching dam types:", error);
    } finally {
      setLoading(false);
    }
  };

  // Lấy loại đập theo ID
  const fetchDamTypeById = async (damTypeId: string) => {
    try {
      const response = await getDamTypeById(damTypeId);
      dispatch(DAM_TYPES_GET_BY_ID({ damType: response.data }));
    } catch (error) {
      console.error("Error fetching dam type by ID:", error);
    }
  };

  // Tạo mới loại đập
  const addDamType = async (data) => {
    try {
      const response = await createDamType(data);
      dispatch(DAM_TYPES_ADD({ damType: response.data }));
      await fetchDamTypes();
    } catch (error) {
      console.error("Error creating dam type:", error);
    }
  };

  // Cập nhật loại đập
  const editDamType = async (data) => {
    try {
      const response = await updateDamType(data);
      dispatch(DAM_TYPES_UPDATE({ damType: response.data }));
      await fetchDamTypes();
    } catch (error) {
      console.error("Error updating dam type:", error);
    }
  };

  // Xoá loại đập
  const removeDamType = async (damTypeId: string) => {
    try {
      await deleteDamType(damTypeId);
      dispatch(DAM_TYPES_DELETE({ damTypeId }));
      await fetchDamTypes();
    } catch (error) {
      console.error("Error deleting dam type:", error);
    }
  };

  return {
    damTypes,
    selectedDamType,
    isLoading,
    fetchDamTypeById,
    addDamType,
    editDamType,
    removeDamType,
    fetchDamTypes
  };
}

export default useDamType;
